/**
 * SupportCenterPage
 * Dono do `PageShell` da Central de Atendimento. Abre no painel (números, avaliações,
 * time de suporte) e só entra no chat de fato quando o Adm escolhe "Abrir conversas".
 */
import React, { useCallback, useState } from 'react';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { PageShell } from '../../components';
import { useSupportStats } from '../../hooks/useSupportStats';
import { SupportPanel } from './SupportPanel';
import { SupportInboxView } from './SupportInboxView';

type SupportCenterView = 'painel' | 'conversas';

export const SupportCenterPage: React.FC = () => {
  const [view, setView] = useState<SupportCenterView>('painel');
  const { stats, isLoading, reload } = useSupportStats(view === 'painel');

  const abrirConversas = useCallback(() => setView('conversas'), []);
  const voltarAoPainel = useCallback(() => setView('painel'), []);

  return (
    <PageShell
      breadcrumbs={[{ label: 'Início', path: '/' }, { label: 'Central de Atendimento' }]}
      title="Central de Atendimento"
      subtitle={view === 'painel' ? 'Avaliações, time de suporte e conversas em um só lugar' : undefined}
      actions={
        view === 'conversas' ? (
          <Button startIcon={<ArrowBack />} onClick={voltarAoPainel}>
            Voltar ao painel
          </Button>
        ) : undefined
      }
    >
      {view === 'painel' ? (
        <SupportPanel stats={stats} isLoading={isLoading} onOpenConversations={abrirConversas} onReload={reload} />
      ) : (
        <SupportInboxView />
      )}
    </PageShell>
  );
};

export default SupportCenterPage;
